import { useRouter } from 'next/router'

export const useAbsUrl = () => {
  const router = useRouter()
  return `${process.env.NEXT_PUBLIC_WEB_URL}${router.asPath}`
}
